import styled from '@emotion/styled';

type ICustomTextProps = {
  fsize?: string;
  fweight?: number;
  margin?: string;
  color?: string;
  bcolor?: string;
  talign?: string;
  tdecorline?: string;
  padding?: string;
  lheight?: string;
  bradius?: string;
  height?: string;
  width?: string;
  fontType?: string;
  cursor?: string;
}

export const H3 = styled.h3`
    font-weight: 500;
`;

export const H1 = styled.h1`
    font-weight: 500;
    font-size: 18px;
`;

export const CustomText = styled.div<ICustomTextProps>`
    font-size: ${(props) => props.fsize};
    font-weight: ${(props) => props.fweight};
    margin: ${(props) => props.margin};
    color: ${(props) => props.color};
    background-color: ${(props) => props.bcolor};
    text-align: ${(props) => props.talign};
    text-decoration-line: ${(props) => props.tdecorline};
    padding: ${(props) => props.padding};
    line-height: ${(props) => props.lheight};
    border-radius: ${(props) => props.bradius};
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    font-family: ${(props) => `Maison Neue ${props.fontType ? props.fontType : ''}, serif`};
    cursor:  ${(props) => props.cursor};
`;

export default CustomText;